import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Spinner } from '~/ui/core/spinner/Spinner';

import { PromptShell } from './PromptShell';

/**
 * Status-only prompt rendered while the role/level is being (re)generated.
 * No CTAs — the prompt reflects a state transition, not a user choice.
 */
export const GeneratingPrompt: FunctionComponent<{ readonly jobType: string }> = ({ jobType }) => {
    const translate = useTranslate();

    return (
        <PromptShell
            question={translate('pages.job-architecture-v2.prompts.generating-question', { jobType })}
            leading={<Spinner className="text-warning-800" style={{ width: 14, height: 14 }} />}
            contextLine={translate('pages.job-architecture-v2.prompts.generating-status')}
        />
    );
};
